<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<p class="ChapterHeader">Table of Contents</p>
<p class="TOC-copy ParaOverride-2"><a href="#/07prlg">Prologue</a></p>
<p class="TOC"><a href="#/ch01">1.     Skipper’s Point</a></p>
<p class="TOC"><a href="#/ch02">2.     Gurney and Red</a></p>
<p class="TOC"><a href="#/ch03">3.     Paradise</a></p>
<p class="TOC"><span href="#/ch04" title="Link target outside of Sample">4.     Old Resident</span></p>
<p class="TOC"><span href="#/ch05" title="Link target outside of Sample">5.     A Hermit</span></p>
<p class="TOC"><span href="#/ch06" title="Link target outside of Sample">6.     A Dueler’s Edge</span></p>
<p class="TOC"><span href="#/ch07" title="Link target outside of Sample">7.     The Angel of Scotts Branch</span></p>
<p class="TOC"><span href="#/ch08" title="Link target outside of Sample">8.     The House on Honeysuckle Way</span></p>
<p class="TOC"><span href="#/ch09" title="Link target outside of Sample">9.     A Roll from the Hay</span></p>
<p class="TOC"><span href="#/ch10" title="Link target outside of Sample">10.   Just a Tad Gone Bad</span></p>
<p class="TOC"><span href="#/ch11" title="Link target outside of Sample">11.   Children of Summer</span></p>
<p class="TOC"><span href="#/ch12" title="Link target outside of Sample">12.   Can’t Get It Back</span></p>
<p class="TOC"><span href="#/ch13" title="Link target outside of Sample">13.   Sunny’s Knights</span></p>
<p class="TOC"><span href="#/ch14" title="Link target outside of Sample">14.   Storm of Darkness</span></p>
<p class="TOC"><span href="#/ch15" title="Link target outside of Sample">15.   Hell in Paradise</span></p>
<p class="TOC"><span href="#/ch16" title="Link target outside of Sample">16.   Certain Men</span></p>
<p class="TOC"><span href="#/ch17" title="Link target outside of Sample">17.   Franco’s Tutorial</span></p>
<p class="TOC"><span href="#/ch18" title="Link target outside of Sample">18.   Dark Places</span></p>
<p class="TOC"><span href="#/ch19" title="Link target outside of Sample">19.   Some Are Just Visiting</span></p>
<p class="TOC"><span href="#/ch20" title="Link target outside of Sample">20.   Winter’s Map</span></p>
<p class="TOC"><span href="#/ch21" title="Link target outside of Sample">21.   Sunny’s Return</span></p>
<p class="TOC"><span href="#/ch22" title="Link target outside of Sample">22.   Junebug’s Lament</span></p>
<p class="TOC"><span href="#/ch23" title="Link target outside of Sample">23.   Box of Ghosts</span></p>
<p class="TOC"><span href="#/ch24" title="Link target outside of Sample">24.   Coco Friday’s Rhythm</span></p>
<p class="TOC"><span href="#/ch25" title="Link target outside of Sample">25.   Midnight’s Fever Dream</span></p>
<p class="TOC"><span href="#/ch26" title="Link target outside of Sample">26.   Searching for Innocence</span></p>
<p class="TOC"><span href="#/ch27" title="Link target outside of Sample">27.   Jake’s Place</span></p>
<p class="TOC"><span href="#/ch28" title="Link target outside of Sample">28.   Blood Brothers Forever</span></p>
<p class="TOC"><span href="#/ch29" title="Link target outside of Sample">29.   Trinity River Bottom Ruminations</span></p>
<p class="TOC"><span href="#/ch30" title="Link target outside of Sample">30.   The Heart of Dixie</span></p>
<p class="TOC"><span href="#/ch31" title="Link target outside of Sample">31.   Xavier</span></p>
<p class="TOC"><span href="#/ch32" title="Link target outside of Sample">32.   The Mouse Trap Confessional</span></p>
<p class="TOC"><span href="#/ch33" title="Link target outside of Sample">33.   Receiving the Cane</span></p>
<p class="TOC"><span href="#/ch34" title="Link target outside of Sample">34.   The Devil Sang</span></p>
<p class="TOC"><span href="#/ch35" title="Link target outside of Sample">35.   The Devil’s Domain</span></p>
<p class="TOC"><span href="#/ch36" title="Link target outside of Sample">36.   Children after Midnight</span></p>
<p class="TOC"><span href="#/ch37" title="Link target outside of Sample">37.   Right the Wrong</span></p>
<p class="TOC"><span href="#/ch38" title="Link target outside of Sample">38.   Hermit of Paradise</span></p>
<p class="TOC-copy ParaOverride-2"><span href="#/ch39" title="Link target outside of Sample">Acknowlegments</span></p>
<p class="TOC-copy ParaOverride-2"><span href="#/ch40" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06-toc.vue?52f5343a